// var $ = require("jquery");
// require("jquery/package.json");

//
// JS
//
import './modules/functions.js';
import './modules/hero.js';
import './modules/swiper.js';
import './modules/navigation.js';
import './modules/blocks.js';
import './modules/forms.js';
import './modules/components.js';
import './modules/instagram.js';
import './modules/accessibility.js';
import './modules/layout.js';
import './modules/canvas.js';

//
// Stylesheet
//
import "../sass/style.scss";


document.addEventListener("DOMContentLoaded", function () {

	const Masonry = require('masonry-layout');

	var grid = document.querySelector('.grid');
	if(grid) {
		var masonry = new Masonry(grid, {
			itemSelector: '.grid-item',
			// columnWidth: 160,
			gutter: 20,
			transitionDuration: '0.2s'
			// Other options and settings here
		});
	}
});

document.addEventListener('DOMContentLoaded', function() {
	var container = document.getElementById('grid');
	if(container) {
		var nextPageURL = document.getElementById('next-page-url').textContent;
		console.log(nextPageURL);
		var isLoading = false;

		const Masonry = require('masonry-layout');
		var masonry; // Declare Masonry instance variable

		function initMasonry() {
			masonry = new Masonry(container, {
				itemSelector: '.grid-item',
				gutter: 20,
				transitionDuration: '0.2s'
			});
		}

		initMasonry(); // Initialize Masonry initially

		function loadMoreContent() {
			if (isLoading || isEndOfContent) return; // Don't load more if we've reached the end
			isLoading = true;
			var isEndOfContent = false; // Add a flag for the end of content
			var loadingIndicator = document.getElementById('loading-indicator');
			loadingIndicator.style.display = 'flex';

			fetch(nextPageURL)
				.then(function(response) {
					return response.text();
				})
				.then(function(data) {
					var parser = new DOMParser();
					var doc = parser.parseFromString(data, 'text/html');
					var newItems = doc.querySelectorAll('.grid-item');

					if (newItems.length === 0) {
						// No more content to load
						isEndOfContent = true;
						loadingIndicator.style.display = 'none';
						return;
					}

					newItems.forEach(function(item) {
						container.appendChild(item);
					});

					// Update the next page URL
					nextPageURL = doc.getElementById('next-page-url').textContent;
					isLoading = false;
					loadingIndicator.style.display = 'none';

					// Inform Masonry of new items and recalculate layout
					masonry.reloadItems();
					masonry.layout();
				})
				.catch(function(error) {
					console.error('Error loading more content:', error);
					isLoading = false;
					loadingIndicator.style.display = 'none';
				});
		}

		// Listen for the scroll event and trigger loading more content
		window.addEventListener('scroll', function() {
			var scrollY = window.scrollY || window.pageYOffset;
			var windowHeight = window.innerHeight || document.documentElement.clientHeight;
			var documentHeight = document.body.scrollHeight;

			// Adjust this threshold as needed
			var scrollThreshold = 100;

			if (scrollY + windowHeight >= documentHeight - scrollThreshold) {
				loadMoreContent();
			}
		});
	}
});


// document.write(`
// <style type="text/css">
// 	${capsizedStyleRule}
// </style>
// <div class="capsizedText">
// 	My capsized text 🛶
// </div>
// `);

// // src/index.js
// import { createStyleObject } from '@capsizecss/core';
// // import fontMetrics from '@capsizecss/metrics/verdana';

// const styles = createStyleObject({
// 	capHeight: 16,
// 	lineGap: 8,
// 	fontMetrics: {
// 		capHeight: 16,
// 		ascent: 1058,
// 		descent: -291,
// 		lineGap: 0,
// 		unitsPerEm: 1000,
// 	},
// });

// // Apply styles to all headings
// const capSizeStyles = document.querySelectorAll('.button span');
// capSizeStyles.forEach((capSizeStyle) => {
// 	capSizeStyle.style = headingStyles;
// });
